export const getDisplayNameFromToken = (token: string | null): string => {
  if (!token) return "";
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return "";
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    const decoded = JSON.parse(jsonPayload);
    if (decoded?.sipAccount && typeof decoded.sipAccount === "string") {
      const displayNameMatch = decoded.sipAccount.match(/displayName:([^,)]+)/);
      if (displayNameMatch && displayNameMatch[1]) {
        return displayNameMatch[1].trim();
      }
    }
    return decoded?.username || decoded?.displayName || "";
  } catch (error) {
    console.error("Failed to decode JWT token:", error);
    return "";
  }
};
